import React from 'react';
import './whychoose.css'

const Whychoose = (props) => {
    return ( <>
    <div className='whychooseusdiv'>
        <img className='whyicon' src={props.whyicon} alt="" />
        <h5 className='whytitle'>{props.whytitle}</h5>
        <p className='whyp'>{props.whyp}</p>
    </div>
    </> );
}
 
export default Whychoose;